<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title v-if="org_id == 'sanjivani' || 'mkd'">
                    <strong> Learner Marksheet Config</strong>
                </v-toolbar-title>
                <v-toolbar-title v-else>
                    <strong> Hide / Show Learner Percentage / Total</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" outlined persistent-hint
                        hint="Please Select Academic Year" @change="getassschemedetails()"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
                        item-value="id" label="Standard" outlined @change="getStandard();" persistent-hint
                        hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2" v-if="std != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="div" :items="dision_list" item-text="div_name"
                        item-value="div_off_id" label="Division" outlined persistent-hint
                        hint="Please Select Division"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="asd"
                        :items="assessment_detail_list" item-text="assessmenttype" item-value="id" return-object
                        label="Assessment Type" persistent-hint hint="Please select Assessment Type"
                        @click="show = false" />
                </v-col>
                 <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="sem" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" v-if="asd" @click="getAllReport()"
                        :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="this.selected.length > 0">
                <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                    <v-autocomplete rounded outlined dense v-model="show_marksheet" :items="show_list" item-text="name"
                        item-value="id" label="Show In Marksheet" persistent-hint single-line></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="this.selected.length > 0">
                    <strong>Total Selected - {{ selected.length }}</strong>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn rounded class="button mt-6" :loading="loader" v-if="learner_info != ''"
                        @click="saveBlockUnblockResult()">Save / Update</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info != ''">
                <v-data-table v-if="org_id == 'sanjivani' || 'mkd'" :headers="headers_sanjivani" @current-items="getFiltered"
                    :items-per-page="25" :items="bookList1" dense sort-by="" class="elevation-1 mytable"
                    :search="search" show-select v-model="selected" item-key="id">
                    <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                    <template v-slot:item.hide_percentage_total="{ item }">
                        <!-- <span v-if="item.hide_percentage_total!='Config Not Set'">
                            <span v-if="item.hide_percentage_total">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </span>
                        <span v-else>
                            <strong style="color: red;">{{item.hide_percentage_total}}</strong>
                        </span> -->
                        <v-switch v-model="item.block_status_2" small color="success"></v-switch>
                    </template>
                </v-data-table>
                <v-data-table v-else :headers="headers" @current-items="getFiltered" :items-per-page="25"
                    :items="bookList1" dense sort-by="" class="elevation-1 mytable" :search="search" show-select
                    v-model="selected" item-key="id">
                    <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                    <template v-slot:item.hide_percentage_total="{ item }">
                        <span v-if="item.hide_percentage_total!='Config Not Set'">
                            <span v-if="item.hide_percentage_total">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </span>
                        <span v-else>
                            <strong style="color: red;">{{item.hide_percentage_total}}</strong>
                        </span>
                    </template>
                </v-data-table>
                <center>
                    <v-btn rounded class="button mt-6" :loading="loader"
                        v-if="learner_info != '' && org_id == 'sanjivani' || 'mkd'" @click="saveBlockUnblockResultsgs()">Save /
                        Update</v-btn>
                </center>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed


export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                loader: false,
                color: "",
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                snackbar: false,
                search: "",
                snackbar_msg: null,
                current_academic_year: null,
                div: null,
                std: "",
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: null,
                learner_info: [],
                show: false,
                overlay: false,
                selected: [],
                total_selected: [],
                selectAll: false,
                search1: "",
                assessment_detail_list: [],
                semester_list:null,
                sem:null,
                asd: null,
                show_list: [
                    { name: "Hide", id: "0" },
                    { name: "Show", id: "1" },
                ],
                show_marksheet: null,
                filterArr: [],
                filters: {
                    reg_no: [],
                    standard: [],
                    div: [],
                    name: [],
                },
                headers: [
                    { text: "Sr. No.", value: "sr_no" },
                    { text: "Registration No.", value: "reg_no" },
                    { text: "Name", value: "name" },
                    { text: "Standard", value: "standard" },
                    { text: "Division", value: "div" },
                    { text: "Hide / Show", value: "hide_percentage_total" },
                ],
                headers_sanjivani: [
                    { text: "Sr. No.", value: "sr_no" },
                    { text: "Block / Unblock Result", value: "hide_percentage_total" },
                    { text: "Registration No.", value: "reg_no" },
                    { text: "Name", value: "name" },
                    { text: "Standard", value: "standard" },
                    { text: "Division", value: "div" },
                    { text: "Total Marks", value: "totalmarks" },
                    { text: "Obtained Marks", value: "obtained_marks" },
                    { text: "Percentage", value: "percentage_converted" },
                    { text: "Fail Subject Count", value: "count" },
                    { text: "Result Rank", value: "result_rank" },
                    { text: "Percentage Rank", value: "percentage_rank" },
                    { text: "Already Assigned Result Rank", value: "lams_rank" },
                    { text: "Already Assigned Percentage Rank", value: "lams_percentage_rank" },
                    
                ],
                role: null,
                org_id: null,
            };
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.learner_info.map((d) => d[val]);
            },
            saveBlockUnblockResultsgs(){
                const data = {
                    asd: this.asd.id,
                    ay: this.current_academic_year.id,
                    learner_info: this.learner_info,
                };
                this.loader = true;
                axios
                    .post("/WWSExamination/saveLearnerMarksheetRank", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Save successfully");
                            this.getAllReport();
                            this.loader = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.loader = false;
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.loader = false;
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                    })
                    .finally(() => {
                        this.selected = [];
                        this.total_selected = [];
                    });
            },
            saveBlockUnblockResult() {
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_selected.push(this.selected[i].id);
                }
                const data = {
                    asd: this.asd.id,
                    ay: this.current_academic_year.id,
                    learner_info: this.total_selected,
                    hide_percentage_total: this.show_marksheet,
                };
                this.loader = true;
                axios
                    .post("/WWSExamination/saveLearnerMarksheetConfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Save successfully");
                            this.getAllReport();
                            this.loader = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                            this.loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.loader = false;
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                    })
                    .finally(() => {
                        this.selected = [];
                        this.total_selected = [];
                    });
            },
            getassschemedetails() {
                const data = {
                    ay: this.current_academic_year.id,
                };
                axios
                    .post("/WWSExamination/getassschemedetailsconfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg_flag);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            getAllReport() {
                this.role = localStorage.getItem("para_role");
                const data = {
                    div: this.div,
                    ay: this.current_academic_year.id,
                    std: this.std,
                    asd: this.asd.id,
                    role: this.role,
                    sem: this.sem
                };
                this.overlay = true;
                axios
                    .post("/WWSExamination/getLearnerMarksheetConfigData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_info = res.data.learner_info;
                            //  this.assignRanksByDivision()
                            if (this.org_id == "sanjivani" || 'mkd') {
                                let studentsByDivision = this.learner_info.reduce((result, student) => {
                                    if (!result[student.div]) {
                                        result[student.div] = [];
                                    }
                                    result[student.div].push(student);
                                    return result;
                                }, {});

                               Object.keys(studentsByDivision).forEach((division) => {
                                    let divisionStudents = studentsByDivision[division];

                                    // Add remark (PASS or F + fail_count)
                                    divisionStudents.forEach((student) => {
                                        student.remark = student.fail_count > 0 ? "F" + student.fail_count : "PASS";
                                    });

                                    // ✅ Sort students with precise priority:
                                    // 1. PASS first
                                    // 2. Among FAILS, F1 → F2 → F3 → …
                                    // 3. Within each group, sort by percentage (descending)
                                    divisionStudents.sort((a, b) => {
                                        const isAPass = a.remark === "PASS";
                                        const isBPass = b.remark === "PASS";

                                        // PASS first
                                        if (isAPass && !isBPass) return -1;
                                        if (!isAPass && isBPass) return 1;

                                        // Both PASS → sort by percentage desc
                                        if (isAPass && isBPass) return b.percentage - a.percentage;

                                        // Both FAIL → compare F-level first (F1 before F2, etc.)
                                        const failA = parseInt(a.remark.substring(1));
                                        const failB = parseInt(b.remark.substring(1));

                                        if (failA !== failB) return failA - failB; // F1 before F2
                                        return b.percentage - a.percentage; // same fail level → sort by percentage desc
                                    });

                                    // ✅ Assign ranks (skip next number if % and remark are same)
                                    let lastPercentage = null;
                                    let lastRemark = null;
                                    let lastRank = 0;
                                    let actualPosition = 0;

                                    divisionStudents.forEach((student) => {
                                        actualPosition++;

                                        // Assign same rank if both % and remark are same
                                        if (student.percentage !== lastPercentage || student.remark !== lastRemark) {
                                            lastRank = actualPosition;
                                        }

                                        student.percentage_rank = lastRank;
                                        student.result_rank = student.fail_count > 0 ? student.remark : lastRank;

                                        lastPercentage = student.percentage;
                                        lastRemark = student.remark;
                                    });
                                });

                            }
                            //console.log(this.learner_info)
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fsmg);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.overlay = false;
                    })
                    .finally(() => {});
            },
            getStandard() {
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                };
                axios
                    .post("/InstallmentStructureDetails/getStandard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dision_list = res.data.dision_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/InstallmentStructureDetails/getAllData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.ay_data;
                            this.current_academic_year = res.data.cay;
                            this.standard_list = res.data.standard_list;
                            this.semester_list = res.data.semester_list
                            this.getassschemedetails();
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        computed: {
            bookList1() {
                return this.learner_info.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
